import {
    SvgIcon as MuiSvgIcon,
    SvgIconProps as MuiSvgIconProps
} from '@mui/material';
import * as React from 'react';

import { withVersion } from '../../utils';
import { Icon, type IconProps } from '../base-icon';

const IconInstagramSvg = (props: MuiSvgIconProps) => (
    <MuiSvgIcon {...props} viewBox="0 0 132.004 132">
        <rect
            x="12"
            y="12"
            width="108"
            height="108"
            rx="30"
            fill="none"
            stroke="currentColor"
            strokeWidth="12"
        />
        <circle
            cx="66"
            cy="66"
            r="25"
            fill="none"
            stroke="currentColor"
            strokeWidth="12"
        />
        <circle cx="98" cy="34" r="7" fill="currentColor" />
    </MuiSvgIcon>
);

export const IconInstagram = withVersion(
    React.forwardRef<SVGSVGElement, IconProps>((props, ref) => (
        <Icon
            ref={ref}
            iconComponent={IconInstagramSvg}
            outlineComponent={IconInstagramSvg}
            roundedComponent={IconInstagramSvg}
            {...props}
        />
    )),
    '1.0.0'
);
